var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBumpy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1525_2691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.75 13C24.75 19.7655 19.2655 25.25 12.5 25.25C5.73451 25.25 0.25 19.7655 0.25 13C0.25 6.23451 5.73451 0.75 12.5 0.75C19.2655 0.75 24.75 6.23451 24.75 13Z",
    fill: "#FBB47E",
    stroke: "#D9925C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 13C25 19.9062 19.4023 25.5 12.5 25.5C8.57031 25.5 5.0625 23.6875 2.76953 20.8477C4.91406 22.582 7.64453 23.6172 10.6172 23.6172C17.5195 23.6172 23.1172 18.0234 23.1172 11.1172C23.1172 8.14453 22.082 5.41406 20.3477 3.26953C23.1836 5.5625 25 9.07031 25 13Z",
    fill: "#D9925C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0926 17.3164C18.0926 17.6922 17.7887 17.9961 17.4129 17.9961H7.58398C7.21211 17.9961 6.9043 17.6922 6.9043 17.3164C6.9043 16.9406 7.21211 16.6367 7.58398 16.6367H17.4129C17.7895 16.6375 18.0926 16.9406 18.0926 17.3164Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5207 12.474C9.54933 12.474 10.3832 11.6402 10.3832 10.6115C10.3832 9.58289 9.54933 8.74902 8.5207 8.74902C7.49207 8.74902 6.6582 9.58289 6.6582 10.6115C6.6582 11.6402 7.49207 12.474 8.5207 12.474Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56339 9.66196C9.40214 9.44526 9.15777 9.35416 9.01757 9.45848C8.87737 9.56281 8.89443 9.82305 9.05569 10.0398C9.21694 10.2565 9.46131 10.3476 9.60151 10.2432C9.74171 10.1389 9.72464 9.87867 9.56339 9.66196Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4758 12.474C17.5044 12.474 18.3383 11.6402 18.3383 10.6115C18.3383 9.58289 17.5044 8.74902 16.4758 8.74902C15.4472 8.74902 14.6133 9.58289 14.6133 10.6115C14.6133 11.6402 15.4472 12.474 16.4758 12.474Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5184 9.66397C17.3572 9.44729 17.1128 9.35621 16.9726 9.46054C16.8324 9.56486 16.8495 9.82508 17.0108 10.0418C17.172 10.2584 17.4164 10.3495 17.5566 10.2452C17.6967 10.1409 17.6797 9.88064 17.5184 9.66397Z",
    fill: "#5A5F63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1525_2691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBumpy);
export default __webpack_public_path__ + "static/media/bumpy.0e424054f391cb2de852eb1de57ca2b7.svg";
export { ForwardRef as ReactComponent };